interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "THB";
};

const THB: Currency = Object.freeze({
  "displayName": "Thai Baht",
  "numericCode": 764,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "THB",
  "symbol": "฿"
});

export { THB };
